/* tslint:disable */
/* eslint-disable */
/**
 * HashiCorp Cloud Platform Vagrant Box Registry
 * API for managing Vagrant boxes.
 *
 * The version of the OpenAPI document: 2022-09-30
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { HashicorpCloudVagrant20220930CreateProviderResponseFromJSON, HashicorpCloudVagrant20220930GetProviderResponseFromJSON, HashicorpCloudVagrant20220930ListProvidersResponseFromJSON, HashicorpCloudVagrant20220930ReadProviderResponseFromJSON, HashicorpCloudVagrant20220930UpdateProviderResponseFromJSON, InlineObject4ToJSON, InlineObject5ToJSON, } from '../models';
/**
 *
 */
export class ProviderServiceApi extends runtime.BaseAPI {
    /**
     * CreateProvider creates a Provider in the specified Version.
     */
    async createProviderRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling createProvider.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling createProvider.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling createProvider.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createProvider.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject4ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930CreateProviderResponseFromJSON(jsonValue));
    }
    /**
     * CreateProvider creates a Provider in the specified Version.
     */
    async createProvider(registry, box, version, body) {
        const response = await this.createProviderRaw({ registry: registry, box: box, version: version, body: body });
        return await response.value();
    }
    /**
     * DeleteProvider deletes a Provider. Note that this deletes any data associated with a Hosted Provider, so use with care.
     */
    async deleteProviderRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling deleteProvider.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling deleteProvider.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling deleteProvider.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling deleteProvider.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response);
    }
    /**
     * DeleteProvider deletes a Provider. Note that this deletes any data associated with a Hosted Provider, so use with care.
     */
    async deleteProvider(registry, box, version, provider) {
        const response = await this.deleteProviderRaw({ registry: registry, box: box, version: version, provider: provider });
        return await response.value();
    }
    /**
     * GetProvider fetches a Provider for the specified Version. NOTE: This is deprecated and should be removed once confirmed the UI is not longer using it
     */
    async getProviderRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling getProvider.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling getProvider.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling getProvider.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling getProvider.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/g_providers/{provider}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930GetProviderResponseFromJSON(jsonValue));
    }
    /**
     * GetProvider fetches a Provider for the specified Version. NOTE: This is deprecated and should be removed once confirmed the UI is not longer using it
     */
    async getProvider(registry, box, version, provider) {
        const response = await this.getProviderRaw({ registry: registry, box: box, version: version, provider: provider });
        return await response.value();
    }
    /**
     * ListProviders lists all Providers within a Version.
     */
    async listProvidersRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling listProviders.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling listProviders.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling listProviders.');
        }
        const queryParameters = {};
        if (requestParameters.paginationPageSize !== undefined) {
            queryParameters['pagination.page_size'] = requestParameters.paginationPageSize;
        }
        if (requestParameters.paginationNextPageToken !== undefined) {
            queryParameters['pagination.next_page_token'] = requestParameters.paginationNextPageToken;
        }
        if (requestParameters.paginationPreviousPageToken !== undefined) {
            queryParameters['pagination.previous_page_token'] = requestParameters.paginationPreviousPageToken;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ListProvidersResponseFromJSON(jsonValue));
    }
    /**
     * ListProviders lists all Providers within a Version.
     */
    async listProviders(registry, box, version, paginationPageSize, paginationNextPageToken, paginationPreviousPageToken) {
        const response = await this.listProvidersRaw({ registry: registry, box: box, version: version, paginationPageSize: paginationPageSize, paginationNextPageToken: paginationNextPageToken, paginationPreviousPageToken: paginationPreviousPageToken });
        return await response.value();
    }
    /**
     * ReadProvider fetches a Provider for the specified Version.
     */
    async readProviderRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling readProvider.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling readProvider.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling readProvider.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling readProvider.');
        }
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930ReadProviderResponseFromJSON(jsonValue));
    }
    /**
     * ReadProvider fetches a Provider for the specified Version.
     */
    async readProvider(registry, box, version, provider) {
        const response = await this.readProviderRaw({ registry: registry, box: box, version: version, provider: provider });
        return await response.value();
    }
    /**
     * Note that you don\'t use this to upload data to Hosted Providers, to do that, use the Upload method.
     * UpdateProvider updates details about a specified Provider.
     */
    async updateProviderRaw(requestParameters) {
        if (requestParameters.registry === null || requestParameters.registry === undefined) {
            throw new runtime.RequiredError('registry', 'Required parameter requestParameters.registry was null or undefined when calling updateProvider.');
        }
        if (requestParameters.box === null || requestParameters.box === undefined) {
            throw new runtime.RequiredError('box', 'Required parameter requestParameters.box was null or undefined when calling updateProvider.');
        }
        if (requestParameters.version === null || requestParameters.version === undefined) {
            throw new runtime.RequiredError('version', 'Required parameter requestParameters.version was null or undefined when calling updateProvider.');
        }
        if (requestParameters.provider === null || requestParameters.provider === undefined) {
            throw new runtime.RequiredError('provider', 'Required parameter requestParameters.provider was null or undefined when calling updateProvider.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling updateProvider.');
        }
        const queryParameters = {};
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // bearer authentication
        }
        const response = await this.request({
            path: `/vagrant/2022-09-30/registry/{registry}/boxes/{box}/versions/{version}/providers/{provider}`.replace(`{${"registry"}}`, encodeURIComponent(String(requestParameters.registry))).replace(`{${"box"}}`, encodeURIComponent(String(requestParameters.box))).replace(`{${"version"}}`, encodeURIComponent(String(requestParameters.version))).replace(`{${"provider"}}`, encodeURIComponent(String(requestParameters.provider))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: InlineObject5ToJSON(requestParameters.body),
        });
        return new runtime.JSONApiResponse(response, (jsonValue) => HashicorpCloudVagrant20220930UpdateProviderResponseFromJSON(jsonValue));
    }
    /**
     * Note that you don\'t use this to upload data to Hosted Providers, to do that, use the Upload method.
     * UpdateProvider updates details about a specified Provider.
     */
    async updateProvider(registry, box, version, provider, body) {
        const response = await this.updateProviderRaw({ registry: registry, box: box, version: version, provider: provider, body: body });
        return await response.value();
    }
}
